import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

import RecipesForm from "../../components/forms/recipes/RecipesForm";
import EmptyModal from "../../components/modals/EmptyModal";
import type { SnackbarData } from "../../components/Snackbar";
import { withRouter } from "../../shared/utility";
import * as actions from "../../store/actions/index";
import { useRecipeEditorViewModel } from "../../viewmodels/recipes/useRecipeEditorViewModel";

interface CreateRecipeProps {
  addSnackbar: (snackbar: SnackbarData) => void;
  logout: () => void;
}

function CreateRecipe({ addSnackbar, logout }: CreateRecipeProps) {
  const navigate = useNavigate();
  const {
    addBomToIngredient,
    askDeleteRecipe,
    bomItems,
    bomItemsLoading,
    emptyModal,
    getBomItems,
    navigateDestination,
    packagingItems,
    recipe,
    recipeItems,
    saveRecipe,
    setEmptyModelOpen,
    setPackagingItems,
    setRecipeItems,
  } = useRecipeEditorViewModel(logout, addSnackbar, {
    navigateOnCreate: true,
  });

  useEffect(() => {
    if (navigateDestination) {
      navigate(navigateDestination, { replace: true });
    }
  }, [navigateDestination, navigate]);

  return (
    <div>
      <div className="mt-2 px-4 sm:px-6 lg:px-8">
        <h1 className="text-xl font-semibold leading-6 text-gray-900">
          Create Recipe
        </h1>
        <div className="mt-5 rounded-xl border-b border-gray-200 bg-white px-4 py-5">
          <RecipesForm
            bomItemsLoading={bomItemsLoading}
            getBomItems={getBomItems}
            bomItems={bomItems}
            recipeItems={recipeItems}
            addBomToIngredient={addBomToIngredient}
            setEmptyModelOpen={setEmptyModelOpen}
            setRecipeItems={setRecipeItems}
            packagingItems={packagingItems}
            setPackagingItems={setPackagingItems}
            saveRecipe={saveRecipe}
            recipe={recipe}
            askDeleteRecipe={askDeleteRecipe}
            onCancel={() => navigate("/recipes")}
          />
        </div>
      </div>
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
    </div>
  );
}

const mapDispatchToProps = (dispatch: any) => ({
  logout: () => dispatch(actions.logout()),
  addSnackbar: (snackbar: SnackbarData) =>
    dispatch(actions.addSnackbar(snackbar)),
});

export default withRouter(connect(null, mapDispatchToProps)(CreateRecipe));
